import { render, staticRenderFns } from "./commentAudit.vue?vue&type=template&id=40b0f076&"
import script from "./commentAudit.vue?vue&type=script&lang=js&"
export * from "./commentAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports